import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteData,
  getData,
  getDataById,
  postData,
  postDataWithParams,
  updateData,
} from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime: 0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getPurchaseOrderCust = createAsyncThunk(
  "admin/purchase-order",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData(
        "/admin/purchase-order",
        data.token,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getPurchaseOrderCustById = createAsyncThunk(
  "admin/purchase-order/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById(
        "/admin/purchase-order/",
        data.token,
        data.id
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortPurchaseOrderCust = createAsyncThunk(
  "admin/purchase-order/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/admin/purchase-order/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postPurchaseOrderCust = createAsyncThunk(
  "admin/purchase-order/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData(
        "/admin/purchase-order",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deletePurchaseOrderCust = createAsyncThunk(
  "admin/purchase-order/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData(
        "/admin/purchase-order/",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updatePurchaseOrderCust = createAsyncThunk(
  "admin/purchase-order/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/admin/purchase-order/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const purchaseOrderCustSlice = createSlice({
  name: "Purchase Order Store",
  initialState: initialState,
  reducers: {
    addPurchaseOrderCust(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortPurchaseOrderCust(state, action) {
      state.data.docs = action.payload;
    },
    deletePurchaseOrderCust(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editPurchaseOrderCust(state, action) {
      let x = state.data.docs.findIndex(
        (item) => item._id === action.payload._id
      );
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getPurchaseOrderCust.pending]: (state) => {
      state.isLoading = true;
    },
    [getPurchaseOrderCust.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getPurchaseOrderCust.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getPurchaseOrderCustById.pending]: (state) => {
      state.isLoading = true;
    },
    [getPurchaseOrderCustById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getPurchaseOrderCustById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortPurchaseOrderCust.pending]: (state) => {
      state.isLoading = true;
    },
    [sortPurchaseOrderCust.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortPurchaseOrderCust.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postPurchaseOrderCust.pending]: (state) => {
      state.isLoading = true;
    },
    [postPurchaseOrderCust.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postPurchaseOrderCust.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deletePurchaseOrderCust.pending]: (state) => {
      state.isLoading = true;
    },
    [deletePurchaseOrderCust.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deletePurchaseOrderCust.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updatePurchaseOrderCust.pending]: (state) => {
      state.isLoading = true;
    },
    [updatePurchaseOrderCust.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updatePurchaseOrderCust.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const purchaseOrderCustActions = purchaseOrderCustSlice.actions;

export default purchaseOrderCustSlice.reducer;
